import React from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import AIKeyCard from "views/account/AIKeyCard";
import AIPromptCard from "views/account/AIPromptCard";

// Sezione "AI": tutto cio' che riguarda l'intelligenza artificiale in un posto solo (solo super admin).
const AIPage = () => {
  const { t } = useTranslation("account");
  return (
  <div className="content">
    <Container>
      <h2 className="mb-4">{t("ai.pageTitle")}</h2>
      <AIPromptCard />
      <AIKeyCard />
      <Row>
        <Col lg="12">
          <Card className="p-3">
            <CardHeader>
              <h3 className="title">{t("ai.howTitle")}</h3>
            </CardHeader>
            <CardBody>
              <ul className="mb-0">
                <li>
                  <strong>{t("ai.p1a")}</strong>{t("ai.p1b")}
                </li>
                <li>{t("ai.p2")}</li>
                <li>{t("ai.p3")}</li>
                <li>{t("ai.p4")}</li>
                <li>{t("ai.p5")}</li>
              </ul>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  </div>
  );
};

export default AIPage;
